import React from "react";
import { UserProfileDropdown } from "../extras/dropdowns/UserProfileDropdown";
import "./styles.scss";

export function Topbar() {
  return (
    <>
      <div className="topbar" style={{ zIndex: 100 }}>
        <UserProfileDropdown />
      </div>
    </>
  );
}
